module.exports = __webpack_public_path__ + "img/uclub_app.960cea8f.png";